import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components/macro';
import { Text } from '../../typography';
import { SPACINGS, valueToPercent } from '../../utils';

type Section = {
  label: string;
  key: string;
};

type StepperMobileProps = {
  sections: Section[];
  activeSectionKey: string;
  style?: React.CSSProperties;
};

const StepperWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ProgressBar = styled.div<{ progress: number }>`
  position: absolute;
  height: 100%;
  width: 100%;
  transform-origin: left;
  transform: scaleX(${(p) => p.progress / 100});
  transition: transform 0.2s;
  background-color: ${(p) => p.theme.colors.primary};
`;

const ProgressBarWrapper = styled.div`
  position: relative;
  height: 4px;
  width: 100%;
`;

function StepperMobile(props: StepperMobileProps) {
  const { sections, activeSectionKey, style } = props;

  const activeIndex = sections.findIndex((s) => s.key === activeSectionKey);
  const progress = valueToPercent(activeIndex + 1, 0, sections.length);

  const [isScrolled, setIsScrolled] = React.useState(window.scrollY > 0);

  React.useEffect(() => {
    function onScroll() {
      const newIsScrolled = window.scrollY > 0;
      if (newIsScrolled !== isScrolled) setIsScrolled(newIsScrolled);
    }
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [isScrolled]);

  if (progress === 0) return null;

  return (
    <StepperWrapper style={style}>
      <ProgressBarWrapper>
        <ProgressBar progress={progress} />
      </ProgressBarWrapper>
      <AnimatePresence>
        {!isScrolled && (
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Text
              size="xs"
              opacity={50}
              margin="none"
              style={{ marginLeft: SPACINGS[4], marginTop: SPACINGS[1] }}
            >
              {activeIndex + 1}/{sections.length}
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    </StepperWrapper>
  );
}

export default React.memo(StepperMobile);
